import { routes } from '../constants';
import {
	accessoiresIndustrieelImage,
	atexStofZuigerImage,
	industrieleStofzuigersImage,
	vacuumTrucks,
	accessoiresHuishoudelijkImage,
	motoren,
	allProductsHuishoudelijk,
} from '../assets/images/images';

export default {
	aboutUs: {
		id: "aboutUs",
		title: "ABOUT_US.META.TITLE",
		description: "ABOUT_US.META.DESCRIPTION",
	},
	atex: {
		id: "atex",
		title: "ATEX.META.TITLE",
		description: "ATEX.META.DESCRIPTION",
		productPreviewList: [
			{
				uuid: "stofzuigers",
				title: "ATEX.PRODUCTS.STOFZUIGERS",
				img: accessoiresIndustrieelImage,
				to: `${routes.INDUSTRIAL.PRODUCTS}/atex`,
			},
			{
				uuid: "accessoires",
				title: "ATEX.PRODUCTS.ACCESSOIRES",
				img: atexStofZuigerImage,
				to: `${routes.INDUSTRIAL.PRODUCTS}/accessoires`,
			},
			{
				uuid: "allProducts",
				title: "ATEX.PRODUCTS.ALL_PRODUCTS",
				img: industrieleStofzuigersImage,
				to: routes.INDUSTRIAL.PRODUCTS,
			},
		],
		zoneTable: {
			header: [{
				id: "zone",
				label: "ATEX.ZONE.TABLE.HEADER.ZONE",
				className: "zone-cell",
			},
			{
				id: "substance",
				label: "ATEX.ZONE.TABLE.HEADER.SUBSTANCE_GENERATING",
			},
			{
				id: "explosive",
				label: "ATEX.ZONE.TABLE.HEADER.PRESENCE_OF_EXPLOSIVE",
			},
			{
				id: "appliance",
				label: "ATEX.ZONE.TABLE.HEADER.APPLIANCE_CATEGORY"
			}]
			,
			rows: [
				[0, "GAS", "CONTINUOUS", "1G"],
				[20, "DUST", "CONTINUOUS", "1D"],
				[1, "GAS", "PROBABLE", "2G"],
				[21, "DUST", "PROBABLE", "2D"],
				[2, "GAS", "POSSIBLE", "3G"],
				[22, "DUST", "POSSIBLE", "3D"],
			]
		},
	},
	documents: {
		id: "documents",
		title: "DOCUMENTS.META.TITLE",
		description: "DOCUMENTS.META.DESCRIPTION",
	},
	faq: {
		id: "faq",
		title: "FAQ.META.TITLE",
		description: "FAQ.META.DESCRIPTION",
	},
	industrial: {
		id: "industrial",
		title: "INDUSTRIAL.META.TITLE",
		description: "INDUSTRIAL.META.DESCRIPTION",
		productPreviewList: [
			{
				uuid: "stofzuigers",
				title: "INDUSTRIAL.PRODUCTS.STOFZUIGERS",
				img: industrieleStofzuigersImage,
				to: `${routes.INDUSTRIAL.PRODUCTS}/industrial_vacuum`,
			},
			{
				uuid: "accessoires",
				title: "INDUSTRIAL.PRODUCTS.ATEX",
				img: atexStofZuigerImage,
				to: `${routes.INDUSTRIAL.PRODUCTS}/atex`,
			},
			{
				uuid: "allProducts",
				title: "INDUSTRIAL.PRODUCTS.ALL_PRODUCTS",
				img: accessoiresIndustrieelImage,
				to: routes.INDUSTRIAL.PRODUCTS,
			},
		],
	},
	industrialContact: {
		id: "industrialContact",
		title: "INDUSTRIAL_CONTACT.META.TITLE",
		description: "INDUSTRIAL_INDUSTRIAL.META.DESCRIPTION",
	},
	intro: {
		id: "introPage",
		title: "INTRO.META.TITLE",
		description: "INTRO.META.DESCRIPTION",
	},
	household: {
		id: "household",
		title: "HOUSEHOLD.META.TITLE",
		description: "HOUSEHOLD.META.DESCRIPTION",

		productPreviewList: [
			{
				uuid: "motoren",
				title: "ATEX.PRODUCTS.STOFZUIGERS",
				img: atexStofZuigerImage,
				to: `${routes.HOUSEHOLD.PRODUCTS}/engines`,
			},
			{
				uuid: "accessoires",
				title: "ATEX.PRODUCTS.ACCESSOIRES",
				img: accessoiresHuishoudelijkImage,
				to: `${routes.HOUSEHOLD.PRODUCTS}/accessories_household`,
			},
			{
				uuid: "allProducts",
				title: "ATEX.PRODUCTS.ALL_PRODUCTS",
				img: industrieleStofzuigersImage,
				to: routes.HOUSEHOLD.PRODUCTS,
			},
		],
	},
	householdContact: {
		id: "householdContact",
		title: "HOUSEHOLD_CONTACT.META.TITLE",
		description: "HOUSEHOLD_CONTACT.META.DESCRIPTION",
	},
	partners: {
		id: "partners",
		title: "PARTNERS.META.TITLE",
		description: "PARTNERS.META.DESCRIPTION",
	},
	productCategory: {
		id: "productCategory",
		title: "PRODUCT_CATEGORY.META.TITLE",
		description: "PRODUCT_CATEGORY.META.DESCRIPTION",
	},
	productCompare: {
		id: "productCompare",
		title: "PRODUCT_COMPARE.META.TITLE",
		description: "PRODUCT_COMPARE.META.DESCRIPTION",
	},
	productDetail: {
		id: "productDetail",
		title: "PRODUCT_DETAIL.META.TITLE",
		description: "PRODUCT_DETAIL.META.DESCRIPTION",
	},
	productList: {
		id: "productList",
		title: "PRODUCT_LIST.META.TITLE",
		description: "PRODUCT_LIST.META.DESCRIPTION",
	},
	projectDetail: {
		id: "projectDetail",
		title: "PROJECT_DETAIL.META.TITLE",
		description: "PROJECT_DETAIL.META.DESCRIPTION",
	},
	projectOverview: {
		id: "projectOverview",
		title: "PROJECT_OVERVIEW.META.TITLE",
		description: "PROJECT_OVERVIEW.META.DESCRIPTION",
	},
	reference: {
		id: "reference",
		title: "REFERENCE.META.TITLE",
		description: "REFERENCE.META.DESCRIPTION",
	},
	rentDetail: {
		id: "rentDetail",
		title: "RENT_DETAIL.META.TITLE",
		description: "RENT_DETAIL.META.DESCRIPTION",
	},
	rentList: {
		id: "rentList",
		title: "RENT_LIST.META.TITLE",
		description: "RENT_LIST.META.DESCRIPTION",
	},
	repairs: {
		id: "repairs",
		title: "REPAIRS.META.TITLE",
		description: "REPAIRS.META.DESCRIPTION",
		productPreviewList: [
			{
				uuid: "motoren",
				title: "REPAIRS.PRODUCTS.ENGINES",
				img: accessoiresHuishoudelijkImage,
				to: `${routes.HOUSEHOLD.PRODUCTS}/engines`,
			},
			{
				uuid: "accessoires",
				title: "REPAIRS.PRODUCTS.ACCESSOIRES",
				img: motoren,
				to: `${routes.HOUSEHOLD.PRODUCTS}/accessories`,
			},
			{
				uuid: "allProducts",
				title: "REPAIRS.PRODUCTS.ALL_PRODUCTS",
				img: allProductsHuishoudelijk,
				to: routes.HOUSEHOLD.PRODUCTS,
			},
		],
	},
	asbest: {
		id: "asbest",
		title: "ASBEST.META.TITLE",
		description: "ASBEST.META.DESCRIPTION",
		productPreviewList: [
			{
				uuid: "stofzuigers",
				title: "ASBEST.PRODUCTS.INDUSTRIELE_STOFZUIGERS",
				img: industrieleStofzuigersImage,
				to: `${routes.INDUSTRIAL.PRODUCTS}/industrial_vacuum`,
			},
			{
				uuid: "vacuumTrucks",
				title: "ASBEST.PRODUCTS.VACUUM_TUCKS",
				img: vacuumTrucks,
				to: `${routes.INDUSTRIAL.PRODUCTS}/vacuum_trucks`,
			},
			{
				uuid: "allProducts",
				title: "ASBEST.PRODUCTS.ALL_PRODUCTS",
				img: atexStofZuigerImage,
				to: routes.INDUSTRIAL.PRODUCTS,
			},
		],
	},
	maatwerk: {
		id: "maatwerk",
		title: "MAATWERK.META.TITLE",
		description: "MAATWERK.META.DESCRIPTION",
	},
}



// WEBPACK FOOTER //
// ./src/config/page.config.js